module.exports = __webpack_public_path__ + "img/Biology.69a55319.jpg";